module.exports = __webpack_public_path__ + "img/banner_full.4ba7ad9f.jpg";